export default {
  section_title: 'Währung',
  label: 'Währung',
  tooltip:
    'Die Währung für Ihre Preise, Auszahlungen und Berichte. Sie wird bei der Erstellung Ihres Partnerkontos festgelegt und kann hier nicht geändert werden — wenden Sie sich an den Support, falls sie nicht stimmt.',
  from_your_partner: 'Von Ihrem Partner',
  set_for_your_account: 'Für Ihr Konto festgelegt',
};
